import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import DashboardContent from '../components/layout/DashboardContent/DashboardContent';

import { Provider as SnackbarProvider } from '../contexts/SnackbarContext';
import { useLanguageContext } from '../contexts/langContext';
import {
  setMiniSidenav,
  useMaterialUIController,
} from '../contexts/layoutContext';
import { Sidenav, SidenavProps } from '../components/layout/Sidenav';
import { FFRoutes } from '../routes';
import { DashboardNavbar } from '../components/Navbars/DashboardNavbar';
import { DashboardLayout } from '../components/layout/DashboardLayout';
// import ChangeLangFlotingButton from "../components/DevComponents/ChangeLangFloatingButton/ChangeLangFloatingButton";

// const isMobile = 'ontouchstart' in document.documentElement;

export default function HomePage() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, sidenavColor } = controller;
  const { dir } = useLanguageContext();
  const [onMouseEnter, setOnMouseEnter] = useState(false);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  return (
    <SnackbarProvider>
      {/* <ChangeLangFlotingButton /> */}
      <Router>
        <Sidenav
          color={sidenavColor as SidenavProps['color']}
          brand="/gem_logo.png"
          brandName="FairFare"
          routes={FFRoutes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
        <>
          <DashboardLayout>
            <DashboardNavbar />
            {dir === 'ltr' ? (
              <>
                <DashboardContent />
              </>
            ) : (
              <>
                <DashboardContent />
              </>
            )}
          </DashboardLayout>
        </>
      </Router>
    </SnackbarProvider>
  );
}
